require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-chris-eisenbraun.json") })
        }
      }, "path---blog-author-chris-eisenbraun");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-chris-eisenbraun!./.cache/json/blog-author-chris-eisenbraun.json
// module id = 616
// module chunks = 231608221292675